const GOOGLE_MAPS_SCRIPT_ID = 'golia-google-maps-places-script'
const GOOGLE_MAPS_API_KEY = 'AIzaSyDHi20jpKVCTkdIfgWXUQFk56x4FEBh6D4'
const PLACES_READY_TIMEOUT_MS = 10000
const PLACES_READY_POLL_MS = 50

// Con loading=async sia `onload` sia window.google.maps possono essere disponibili
// prima della libreria Places. Aspettiamo importLibrary/places con un timeout finito.
function resolvePlaces(startedAt = Date.now()) {
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
        return window.google.maps.importLibrary('places')
    }
    if (window.google && window.google.maps && window.google.maps.places) {
        return Promise.resolve(window.google.maps.places)
    }

    if (Date.now() - startedAt >= PLACES_READY_TIMEOUT_MS) {
        return Promise.reject(
            new Error('Google Maps caricato ma libreria Places non disponibile')
        )
    }

    return new Promise((resolve) => {
        setTimeout(resolve, PLACES_READY_POLL_MS)
    }).then(() => resolvePlaces(startedAt))
}

export function loadGoogleMapsPlaces() {
    if (window.__goliaGoogleMapsPlacesPromise) {
        return window.__goliaGoogleMapsPlacesPromise
    }

    const promise = new Promise((resolve, reject) => {
        // Script (o google.maps) già presente: importa direttamente la libreria.
        if (window.google && window.google.maps) {
            resolvePlaces().then(resolve, reject)
            return
        }

        const existingScript = document.getElementById(GOOGLE_MAPS_SCRIPT_ID)
        if (existingScript) {
            existingScript.addEventListener('error', reject)
            resolvePlaces().then(resolve, reject)
            return
        }

        const script = document.createElement('script')
        script.id = GOOGLE_MAPS_SCRIPT_ID
        script.async = true
        script.defer = true
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`
        script.onload = () => resolvePlaces().then(resolve, reject)
        script.onerror = reject

        document.head.appendChild(script)
    })

    // Non lasciare in cache una promise fallita: un tentativo successivo potrà riprovare
    // (es. blip di rete) invece di restare bloccato su un errore per tutta la sessione.
    promise.catch(() => {
        if (window.__goliaGoogleMapsPlacesPromise === promise) {
            window.__goliaGoogleMapsPlacesPromise = null
        }
    })

    window.__goliaGoogleMapsPlacesPromise = promise
    return promise
}
